<div class="flex flex-row-reverse">
  <div class="ml-4 mt-auto">
    <aux-menu
      #patient_driver_menu
      [showMenuForExternal]="userHasUploadPatientDriverPermission()"
      [disabled]="workflowCtx.isLocked()"
      [disabledTooltip]="workflowCtx.tooltip()"
    >
      <button
        type="button"
        role="menuitem"
        class="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 focus:outline-none"
        (click)="onPatientDriverUploadClick(); patient_driver_menu.close()"
      >
        <aux-icon name="Upload" />
        <span class="ml-2">Upload</span>
      </button>
    </aux-menu>
  </div>
  <aux-editable-list-dropdown
    [dropdownFormControl]="curveControl"
    [items]="patientCurveListOptions"
    [label]="'Select a Curve:'"
    [classList]="'w-64'"
    [createBtnLabel]="'Create Blended Curve'"
    (edit)="editCurve($event)"
    (delete)="deleteCurve($event)"
    (create)="editCurve()"
    [editDisabled]="disableModifyPatientCurve()"
    [deleteDisabled]="disableModifyPatientCurve()"
    [createDisabled]="disableModifyPatientCurve()"
    [editDisabledTooltip]="disableModifyPatientCurveTooltip()"
    [deleteDisabledTooltip]="disableModifyPatientCurveTooltip()"
    [createDisabledTooltip]="disableModifyPatientCurveTooltip()"
  />
</div>

@if ((loading$ | async) === true) {
  <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
}
@if ((loading$ | async) === false) {
  @if (showEnrollmentSettings()) {
    <div class="w-10/12 rounded border border-aux-gray-dark bg-aux-gray-light px-8 py-4">
      @if ((patientCurveQuery.selectLoading() | async) === false) {
        <div class="mb-4 text-lg font-bold text-black">Enrollment Settings</div>
      } @else {
        <!-- TODO create a skeleton loading for invoice -->
        <div class="spinner m-auto mt-40 h-32 w-32 border-8"></div>
      }
      <div class="grid grid-cols-5 gap-10 whitespace-nowrap text-xs">
        <div>
          <div class="mb-3">Patients Enrolled (pspm)</div>
          <aux-input [type]="'number'" />
        </div>
        <div>
          <div class="mb-3">Total Patients Enrolled</div>
          <aux-input [type]="'number'" />
        </div>
        <div>
          <div class="mb-3">First Patient Enrolled</div>
          <aux-input [type]="'date'" />
        </div>
        <div>
          <div class="mb-3">Average Months Per Patient</div>
          <aux-input [type]="'number'" />
        </div>
        <div>
          <div class="mb-3">Total Enrolled + Dropped</div>
          <aux-input [type]="'number'" />
        </div>
      </div>

      <div class="my-5 flex space-x-4 text-xs">
        <!-- <div class="flex items-center space-x-2">
        <aux-radio-button name="radioGroup" tabIndex="1" [checked]="true" />
        <span>Apply monthly Δ to following month</span>
      </div>
      <div class="flex items-center space-x-2">
        <aux-radio-button name="radioGroup" tabIndex="2" />
        <span>Spread monthly Δ over enrollment period</span>
      </div>
      <div class="flex items-center space-x-2">
        <aux-radio-button name="radioGroup" tabIndex="3" />
        <span>Modify enrollment period (+/- 1 month)</span>
      </div> -->
      </div>

      <div class="mb-5 flex items-center space-x-4 text-xs">
        <button type="button" class="btn btn--blue">Save Edits</button>
        <button class="btn--tertiary" type="button">Cancel</button>
      </div>
    </div>
  }

  <div
    *ngVar="patientDriversEdcFlag()"
    class="mt-5 grid grid-cols-3 space-x-5"
    [ngClass]="{ 'mb-5 flex flex-col': patientDriversEdcFlag() }"
  >
    <div
      class="col-span-2 flex h-full flex-col justify-between"
      [ngClass]="{
        'col-span-2': patientDriversEdcFlag(),
        'col-span-3': !patientDriversEdcFlag(),
      }"
    >
      @if (topCards$ | async) {
        <div class="mb-5 flex-none">
          <aux-ag-patient-driver-upper-cards [topCards]="topCards$" />
        </div>
      }
      <div class="mb-4 mt-[5px] text-xl font-bold text-aux-black">Estimated Enrollment Curve</div>
      <div
        class="flex flex-col"
        [ngClass]="{
          'grow items-center rounded-lg border': patientDriversEdcFlag(),
        }"
      >
        <div
          class="flex w-full items-center justify-center"
          [ngClass]="{
            'h-full': patientDriversEdcFlag(),
          }"
        >
          @if (multiChart$ | async; as multiChart) {
            <div class="w-full flex-shrink-0" [ngClass]="{ 'px-2': patientDriversEdcFlag() }">
              <aux-canvas-chart [chartOptions]="multiChart!" />
            </div>
          }
        </div>
      </div>
    </div>
    @if ((comparisonCards$ | async) && patientDriversEdcFlag()) {
      <div class="col-span-1">
        <aux-ag-patient-driver-comparison-panel [comparisonCards$]="comparisonCards$" />
      </div>
    }
  </div>

  <div class="mb-5 mt-[25px] flex items-center justify-between space-x-4">
    <div class="text-lg font-bold text-black">Enrollment</div>
    @if ((this.gridData$ | async)?.length !== 0) {
      <div class="flex justify-end">
        @if (
          (editMode$ | async) === false &&
          (isBlended$ | async) === false &&
          userHasModifyPermissions()
        ) {
          <aux-button
            label="Edit"
            variant="secondary"
            [disabled]="workflowCtx.isLocked()"
            [auxTooltip]="workflowCtx.tooltip()"
            icon="Pencil"
            [onClick]="this.onEditClick.bind(this)"
          />
        }

        @if ((editMode$ | async) === true && (isBlended$ | async) === false) {
          <button type="button" class="btn--secondary ml-1" (click)="cancelEditMode()">
            <aux-icon name="X" />
            <span class="ml-0.5">Cancel</span>
          </button>
        }

        @if ((editMode$ | async) === true && !isEqual()) {
          <button
            class="btn btn--success ml-1"
            [auxTooltip]="saveBtnTitle()"
            [disabled]="!isEqual() || !wasGridChanged()"
          >
            @if ((btnLoading$ | async) === false && (isBlended$ | async) === false) {
              <aux-icon name="Check" />
            }
            <span class="ml-2">Save</span>
          </button>
        }
        @if ((editMode$ | async) === true && isEqual()) {
          <button
            class="btn btn--success ml-1"
            [auxTooltip]="saveBtnTitle()"
            [disabled]="
              !isEqual() ||
              (editingGridCell$ | async) === true ||
              (isNetPatientNegative$ | async) === true ||
              !wasGridChanged()
            "
            (click)="saveEditMode()"
          >
            @if ((btnLoading$ | async) === true) {
              <span class="spinner h-5 w-5"></span>
            }
            @if ((btnLoading$ | async) === false && (isBlended$ | async) === false) {
              <aux-icon name="Check" />
            }
            <span class="ml-2">Save</span>
          </button>
        }
        <aux-export-excel-button
          className="ml-1"
          [clickFN]="onExportForPatientDriver.bind(this)"
          [spinnerSize]="7"
          pendoTag="patient-curves-excel-export-button"
        />
      </div>
    }
  </div>

  <ag-grid-angular
    class="ag-theme-aux patient-table w-full tabular-nums"
    id="patient-table"
    domLayout="autoHeight"
    [rowData]="gridData$ | async"
    [gridOptions]="gridOptions"
    [enableFillHandle]="(editMode$ | async) === true"
    (gridReady)="onGridReady($event)"
    (cellValueChanged)="cellValueChanged(); onCellValueChanged()"
    (cellEditingStopped)="cellEditingStopped()"
    (firstDataRendered)="onDataRendered($event)"
    (cellEditingStarted)="rowPinnedCheck($event)"
    [tabToNextCell]="tabToNextCell"
    auxStickyGrid
  />
}
